import React from 'react';
import axios from "../../../../containers/api";
import {Alert, Button, CustomInput, FormGroup, Input, Label} from "reactstrap";
import {showCatchError, toCurrency, toEnglishNumbers} from "../../../../helpers/Utils";

class ChargeTransportationCompany extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            OneTransportationCompany: (this.props && this.props.TransportationCompany) ? this.props.TransportationCompany : null,
            //member: JSON.parse(localStorage.getItem("member")),
            creditAmount: "",
            comment: "",
            errors: [],
            showAdd: true,
            luckButton: false
        }
         
    }

    validateInputData = () => {
        this.props.closeSweetAlert();
        let error = [];
        if (this.state.creditAmount < 10000 || this.state.creditAmount === null || this.state.creditAmount === '') {
            error.push('مقدار اعتبار وارد شده نباید کمتر از ۱۰۰۰۰ ریال باشد');
        }
        if (this.state.comment === undefined || this.state.comment === null || this.state.comment.trim() === "") {
            error.push('لطفا توضیحات را وارد کنید');
        }

        this.setState({ errors: error });
        if (error.length === 0) {
            this.chargeAccount();
        } else {
            this.props.showAlert("لطفا تمامی اطلاعات درخواست شده را به درستی وارد کنید!", "error");
        }
    };
    chargeAccount = () => {
        let Api = "", desc = "";
        if (this.state.showAdd === true) {
            Api = "";
            desc = "افزايش شارژ با موفقیت انجام شد";
        } else {
            Api = "DeductCharge";
            desc = "کسر شارژ با موفقیت انجام شد";
        }

        let model = {
            TransportationCompanyId: this.state.OneTransportationCompany.transportationCompanyId,
            Amount: toEnglishNumbers(this.state.creditAmount),
            Description: toEnglishNumbers(this.state.comment),

        };

        this.setState({ luckButton: true });
        this.props.showSpinner();
        axios.post('api/v1/account-activities/' + Api, model)
            .then((res) => {
                if (res.data.statusCode === 200) {
                    this.props.hideSpinner();
                    this.props.showAlert(res.data.message, "success");
                    this.setState({ luckButton: false });
                    this.props.closeModal("ChargeModal");
                }
                else {
                    this.props.showAlert(res.data.message, "error");  
                    this.props.hideSpinner();
                    this.setState({ luckButton: false })
                }
            })
            .catch((error) => {
                this.props.hideSpinner();
                console.log(error.response);
                this.props.showAlert(showCatchError(error), "error");
                this.setState({ luckButton: false });
            });
    };

    render() {
        return (
            <div className="d-flex flex-column w-100">
                <div className="d-flex flex-md-row flex-column justify-content-center flex-wrap w-100 mt-5">
                     
                            <FormGroup className="w-md-25 w-100 px-1">
                                <Label>نام</Label>
                        <Input value={this.state.OneTransportationCompany.transportationCompanyName} readOnly/>
                            </FormGroup>

                            <FormGroup className="w-md-25 w-100 px-1">
                                <Label>شماره موبایل</Label>
                                <Input value={this.state.OneTransportationCompany.mobile} readOnly/>
                    </FormGroup>
                </div>
                    <div className="d-flex flex-md-row flex-column justify-content-center flex-wrap w-100 mt-5">
                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>مقدار اعتبار (ریال)</Label>
                        <Input value={toCurrency(this.state.creditAmount)}
                               onChange={(e) => this.setState({creditAmount: e.target.value.replace(/[^0-9۰-۹]/g, "")})}/>
                    </FormGroup>

                    <FormGroup className="w-md-25 w-100 px-1">
                        <Label>توضیحات</Label>
                        <Input value={this.state.comment}
                               onChange={(e) => this.setState({comment: e.target.value})}/>
                    </FormGroup>
                    </div>
                    <div className="d-flex flex-md-row flex-column justify-content-center flex-wrap w-100 mt-5">
                    <FormGroup className="w-md-25 w-100 px-1 justify-content-center">
                        <CustomInput
                            className="mt-4"
                            type="radio"
                            id="showAddTrue"
                            name="showAdd"
                            label="افزایش"
                            checked={this.state.showAdd}
                            onChange={() => this.setState({showAdd: true})}
                        />
                    </FormGroup>

                    <FormGroup className="w-md-25 w-100 px-1 justify-content-center">
                        <CustomInput
                            className="mt-4"
                            type="radio"
                            id="showAddFalse"
                            name="showAdd"
                            label="کاهش"
                            checked={!this.state.showAdd}
                            onChange={() => this.setState({showAdd: false})}
                        />
                    </FormGroup>
                </div>

                {this.state.errors.length === 0 ?
                    null
                    :
                    <div>
                        {(this.state.errors.map((error, i) => {
                            return (
                                <Alert color="danger" key={i}>{error}</Alert>
                            )
                        }))}
                    </div>
                }

                <div className="d-flex flex-md-row flex-column justify-content-center flex-wrap w-100 mt-5">
                    <FormGroup className="text-center">
                        <Button color="primary" className="btn-lg mx-2" disabled={this.state.luckButton}
                                onClick={() => this.props.showSweetAlert(this.state.showAdd ? "آیا از افزایش اعتبار مطمئن هستید؟" :"آیا از کاهش اعتبار مطمئن هستید؟", "", "success", this.validateInputData)}>
                            شارژ
                        </Button>
                    </FormGroup>
                </div>

            </div>
        );
    }
}

export default ChargeTransportationCompany;